import { useIlpContext } from "../hooks/useIlpContext";
import { Button, FormControl, Grid } from "@mui/material";
import { IAssessmentActionProps } from "../types/interfaces/IAssessmentActionProps";
import { getIlpKeyFromQueryString } from "../../global/utilities/ProcessQueryString";

//This component is responsible for saving/submitting an ilp plan.
const AssessmentAction: React.FC<IAssessmentActionProps> = ({
    onSave,
    onCancel,
    planStatus,
    submitFlag,
    onSubmit,
    onUpdateObjectives,
    onPrint,
    areButtonsDisabled
}) => {
    const { isAdvisorFlag, isAdminFlag } = useIlpContext();
    const isReviewerFlag = isAdvisorFlag || isAdminFlag;
    const isApprovedFlag = planStatus === "Approved";
    const isSubmittedFlag = planStatus === "Submitted";
    const submitText = isSubmittedFlag ? "Resubmit for Approval" : "Submit for Approval";
    const buttonText = isReviewerFlag ? "Approve" : "Save";
    const ilpKey = getIlpKeyFromQueryString();

    const confirmSelection = () => {
        if(isReviewerFlag) {
            if (confirm("Are you sure?") == true) {
                onSave();
            }
        } else {
            onSave();
        }
    };

    return (
        <>
            <FormControl sx={{ paddingBottom: 5 }}>
                <Grid container spacing={1}>

                    {submitFlag && !isReviewerFlag && !isApprovedFlag && (
                        <Grid item>
                            <Button
                                onClick={onSubmit}
                                disabled={areButtonsDisabled}
                                variant="contained"
                                size="large"
                                sx={{ maxWidth: 300, fontSize: 24 }}>
                                {submitText}
                            </Button>
                        </Grid>
                    )}

                    {((!isReviewerFlag && !isSubmittedFlag && !isApprovedFlag) || (isReviewerFlag && !isApprovedFlag)) && (
                        <Grid item>
                            <Button
                                onClick={confirmSelection}
                                disabled={areButtonsDisabled}
                                variant="contained"
                                size="large"
                                sx={{ maxWidth: 100, fontSize: 24 }}>
                                {buttonText}
                            </Button>
                        </Grid>
                    )}

                    {!isReviewerFlag && isApprovedFlag && (
                        <Grid item>
                            <Button
                                onClick={onUpdateObjectives}
                                variant="contained"
                                size="large"
                                sx={{ maxWidth: 300, fontSize: 24 }}>
                                Update Objectives
                            </Button>
                        </Grid>
                    )}

                    {ilpKey == null && <Grid item>
                        <Button
                            onClick={onCancel}
                            disabled={areButtonsDisabled}
                            variant="contained"
                            size="large"
                            sx={{ maxWidth: 100, fontSize: 24 }}>
                            Cancel
                        </Button>
                    </Grid>}

                    <Grid item>
                        <Button
                            onClick={onPrint}
                            variant="contained"
                            size="large"
                            sx={{ maxWidth: 100, fontSize: 24 }}>
                            Print
                        </Button>
                    </Grid>
                </Grid>
            </FormControl>
        </>
    );
};

export default AssessmentAction;